import * as React from 'react';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';

const StyledTab = styled((props) => <Tab {...props} />)(
  ({ theme, style }) => ({
    fontFamily: 'GT Maru',
    textTransform: style?.textTransform || 'capitalize',
    fontWeight: style?.fontWeight || 500,
    fontSize: style?.fontSize || '14px',
    lineHeight: style?.lineHeight || '100%',
    marginRight: theme?.spacing(1),
    color: '#292829',
    opacity: 0.6,
    padding: '8px 16px',
    margin: 0,
    '&.Mui-selected': {
      opacity: 1,
      color: '#292829',
    },
    '&:hover, &.Mui-focusVisible': {
      opacity: 0.8,
    },
  }),
);

export default StyledTab;
